<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card>
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="filter">
              <filter-component
                :filterOfZones="true"
                :filterOfLots="false"
                :isRequiredFarms="false"
                @filter="handleFilter"
                @showHideLoading="showHideLoading"
                classZones="`col-12 col-md-6 col-lg-4 col-xl-4`"
                classFarms="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4"
              >
                <template slot="prev">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 pt-3">
                    <label for=""
                      >{{ $t('common_words.evaluations') }}: *</label
                    >
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect('evaluationsSel', evaluations)
                      "
                      clearable
                      collapse-tags
                      style="width: 100%"
                      multiple
                      filterable
                      class="select-primary custom-width-select shadow-sm required-evaluations"
                      v-model="evaluationsSel"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        class="select-primary selected-all"
                        v-for="item in evaluations"
                        :key="item.id + item.name"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 pt-3">
                    <label for="">{{ $t('grow.training') }}: </label>
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelectActivities(
                          'activitiesSel',
                          activities
                        )
                      "
                      clearable
                      collapse-tags
                      style="width: 100%"
                      multiple
                      filterable
                      class="select-primary custom-width-select shadow-sm"
                      v-model="activitiesSel"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        class="select-primary selected-all"
                        v-for="item in activities"
                        :key="item.id + item.name"
                        :label="item.name"
                        :value="item.id === -1 ? -1 : item.name"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
              </filter-component>
            </el-collapse-item>
          </el-collapse>
        </card>
        <card v-if="tableData.length > 0">
          <br />
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                filterable
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :data="queriedData"
                max-height="500"
                style="width: 100%"
                :border="true"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.fixed"
                  :sortable="column.sortable"
                  :align="column.align"
                  :resizable="false"
                  v-if="showColumn(column.show)"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('common_words.image')"
                  min-width="150"
                  :resizable="false"
                >
                  <template slot-scope="scope">
                    <el-image
                      v-if="scope.row.image"
                      :src="scope.row.image"
                      :alt="$t('common_words.no_image')"
                      class="photo_capture"
                      @click="zoom(scope.row.image)"
                      :preview-src-list="srcList"
                    >
                      <div slot="error" class="image-slot"></div>
                    </el-image>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="isShow() || isDelete()"
                  :min-width="110"
                  :label="$t('common_words.operations')"
                  :resizable="false"
                  fixed="right"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <span v-if="props.row.show">
                        <a
                          v-if="isShow()"
                          v-tooltip.top-center="$t('common_words.view')"
                          class="btn-info btn-simple btn-link custom-margin-actions"
                          @click="handleView(props.$index, props.row)"
                        >
                          <em class="fa fa-eye custom-size-fa-actions"></em>
                        </a>
                      </span>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
          <div
            v-if="
              (isPDF() || isExcel() || isSuper()) &&
              isExportDetailAdvancedAudit()
            "
            class="row"
            style="padding-right: 13px; padding-left: 13px; padding-top: 12px"
          >
            <div class="col-6">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportToPDFAllInspectionsWithDetails"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col-6">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToEXCELAllInspectionsWithDetails"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </card>
        <div v-if="details" class="col-12 text-center">
          <em
            class="nc-icon nc-stre-up"
            style="font-size: 25px; cursor: pointer"
            @click="handleViewDetails"
            v-tooltip.top-center="$t('common_words.hide_detail')"
          ></em>
        </div>
        <card v-if="details">
          <div class="row">
            <div class="col-12">
              <p style="font-size: 17px" class="text-muted">
                {{ $t('common_words.inspection_related_information') }}:
              </p>
            </div>
            <div class="col-12 mb-2">
              <table aria-describedby="table-details" class="table">
                <tbody>
                  <tr class="shadow-sm">
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.farm') }}:</strong>
                      </h6>
                      {{ rowData.farm_name }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.code') }}:</strong>
                      </h6>
                      {{ rowData.code }}
                    </td>
                    <td>
                      <h6>
                        <strong>{{ $t('common_words.save_date') }}:</strong>
                      </h6>
                      {{ rowData.date_save }} | {{ $t('common_words.week') }}:
                      {{ rowData.week_save }}, {{ $t('common_words.day') }}:
                      {{ rowData.day_save }}
                    </td>

                    <!-- Mapa -->
                    <th>
                      <img
                        v-tooltip.top-center="
                          $t('common_words.geo_location_map')
                        "
                        style="width: 30px; height: 30px"
                        class="pointer"
                        src="/static/img/iconos/map.svg"
                        :alt="$t('common_words.geo_location_icon')"
                        @click="handleViewSamplesMap()"
                      />
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- MODAL MAPA DETALLES -->
            <el-dialog
              :title="$t('common_words.samples_map')"
              class="zoom-map el-dialog-img-zoom"
              top="15px"
              width="80%"
              :visible.sync="modals.map"
              :close="handleCloseSamplesMap"
            >
              <div ref="multipleMap" class="map"></div>
              <div id="toolbarDiv" class="esri-component esri-widget">
                <button
                  id="distance"
                  class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.distance_measurement_tool')"
                ></button>
                <button
                  id="area"
                  class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.area_measurement_tool')"
                ></button>
                <button
                  id="clear"
                  class="action-button esri-widget--button esri-interactive esri-icon-trash"
                  style="margin-bottom: 10px"
                  :title="$t('common_words.clear_measurement')"
                ></button>
              </div>
            </el-dialog>

            <el-dialog
              v-if="isUpdate()"
              :title="$t('common_words.edit_sample_report')"
              width="70%"
              top="2%"
              :visible.sync="modals.read"
              destroy-on-close
              @close="handleClose"
              @open="cleanInput"
            >
              <p>
                {{ $t('common_words.selected_record_info') }}
              </p>
              <form @submit.prevent="validate" v-if="this.isUpdate()">
                <card class="shadow-sm">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12">
                          <h6 class="text-muted">
                            1.
                            {{ $t('common_words.inspection_assigned_value') }}
                          </h6>
                          <hr />
                        </div>
                      </div>
                      <div
                        class="row"
                        v-if="
                          option_calification_type[0] &&
                          option_calification_type[0].calification_type ==
                            'Objetiva'
                        "
                      >
                        <div
                          v-if="!option_calification_type[0].is_required"
                          class="col-2 mb-3"
                        >
                          <el-checkbox
                            v-model="detailsForm.na"
                            label="N/A"
                          ></el-checkbox>
                        </div>
                        <div
                          v-if="
                            option_calification_type[0].is_required ||
                            !detailsForm.na
                          "
                          class="col-10 mb-3"
                        >
                          <el-switch
                            class="ml-3"
                            v-model="detailsForm.value"
                            style="display: block"
                            active-color="#20a857"
                            inactive-color="#ff4c4c"
                            active-text="Si"
                            inactive-text="No"
                          >
                          </el-switch>
                        </div>
                      </div>
                      <div
                        class="row mb-3"
                        v-else-if="
                          option_calification_type[0] &&
                          option_calification_type[0].calification_type ==
                            'Fecha'
                        "
                        style="align-items: center"
                      >
                        <div
                          v-if="!option_calification_type[0].is_required"
                          class="col-2"
                        >
                          <el-checkbox
                            v-model="detailsForm.na"
                            label="N/A"
                          ></el-checkbox>
                        </div>
                        <div
                          v-if="
                            option_calification_type[0].is_required ||
                            !detailsForm.na
                          "
                          class="col-6"
                        >
                          <el-date-picker
                            v-if="renderComponent"
                            v-model="detailsForm.value_two"
                            class="shadow-sm required-value_two"
                            type="date"
                            :placeholder="`${$t('common_words.select')}...`"
                          >
                          </el-date-picker>
                        </div>
                      </div>
                      <div
                        class="row mb-3"
                        v-else-if="
                          option_calification_type[0] &&
                          option_calification_type[0].calification_type ==
                            'Hora'
                        "
                        style="align-items: center"
                      >
                        <div
                          v-if="!option_calification_type[0].is_required"
                          class="col-2"
                        >
                          <el-checkbox
                            v-model="detailsForm.na"
                            label="N/A"
                          ></el-checkbox>
                        </div>
                        <div
                          v-if="
                            option_calification_type[0].is_required ||
                            !detailsForm.na
                          "
                          class="col-4"
                        >
                          <el-time-picker
                            class="required-value_two"
                            arrow-control
                            v-model="detailsForm.value_two"
                          >
                          </el-time-picker>
                        </div>
                      </div>
                      <div
                        class="row mb-3"
                        v-else-if="
                          option_calification_type[0] &&
                          option_calification_type[0].calification_type ==
                            'Texto'
                        "
                        style="align-items: center"
                      >
                        <div
                          v-if="!option_calification_type[0].is_required"
                          class="col-2"
                        >
                          <el-checkbox
                            v-model="detailsForm.na"
                            label="N/A"
                          ></el-checkbox>
                        </div>
                        <div
                          v-if="
                            option_calification_type[0].is_required ||
                            !detailsForm.na
                          "
                          class="col-10 mb-0"
                        >
                          <fg-input
                            type="texto"
                            :label="`${$t('common_words.value')}: ${
                              option_calification_type[0].is_required ? `*` : ``
                            }`"
                            v-model="detailsForm.value_two"
                            name="common_words.value"
                            v-validate="modelValidations.value_two"
                            :error="getError('common_words.value', true)"
                            placeholder="..."
                            v-bind:min="
                              parseInt(option_calification_type[0].minimum)
                            "
                            v-bind:max="
                              parseInt(option_calification_type[0].maximum)
                            "
                          >
                          </fg-input>
                        </div>
                      </div>
                      <div
                        class="row"
                        v-else-if="
                          option_calification_type[0] &&
                          option_calification_type[0].calification_type ==
                            'Subjetiva'
                        "
                      >
                        <div class="col-3 mb-3">
                          <el-select
                            @clear="
                              detailsForm.value = option_calification_type[0]
                                .is_required
                                ? null
                                : 11
                            "
                            clearable
                            class="select-primary custom-width-select shadow-sm required-value"
                            size="large"
                            v-model="detailsForm.value"
                            :placeholder="`${$t('common_words.select')}...`"
                            filterable
                          >
                            <el-option
                              v-for="(option, index) in 11"
                              :key="index"
                              class="select-primary"
                              :value="index"
                              :label="index"
                            ></el-option>
                            <el-option
                              v-if="!option_calification_type[0].is_required"
                              class="select-primary"
                              :value="11"
                              label="NA"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>
                      <div
                        class="row"
                        v-else-if="
                          option_calification_type[0] &&
                          option_calification_type[0].calification_type ==
                            'Subjetiva 2'
                        "
                      >
                        <div class="col-3 mb-3">
                          <el-select
                            @clear="
                              detailsForm.value = option_calification_type[0]
                                .is_required
                                ? null
                                : 6
                            "
                            clearable
                            class="select-primary custom-width-select shadow-sm required-value"
                            size="large"
                            v-model="detailsForm.value"
                            :placeholder="`${$t('common_words.select')}...`"
                            filterable
                          >
                            <el-option
                              v-for="(option, index) in 6"
                              :key="index"
                              class="select-primary"
                              :value="index"
                              :label="index"
                            ></el-option>
                            <el-option
                              v-if="!option_calification_type[0].is_required"
                              class="select-primary"
                              :value="6"
                              label="NA"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>
                      <div
                        class="row"
                        v-else-if="
                          option_calification_type[0] &&
                          option_calification_type[0].calification_type ==
                            'Numérica'
                        "
                        style="align-items: center"
                      >
                        <div
                          v-if="!option_calification_type[0].is_required"
                          class="col-2 mb-3"
                        >
                          <el-checkbox
                            v-model="detailsForm.na"
                            label="N/A"
                          ></el-checkbox>
                        </div>
                        <div
                          v-if="
                            option_calification_type[0].is_required ||
                            !detailsForm.na
                          "
                          class="col-6 mb-3"
                        >
                          <fg-input
                            type="number"
                            :label="`${$t('common_words.value')}: ${
                              option_calification_type[0].is_required ? `*` : ``
                            }`"
                            v-model="detailsForm.value_number"
                            name="common_words.value"
                            v-validate="modelValidations.value"
                            :error="getError('common_words.value', true)"
                            placeholder="1"
                            v-bind:min="option_calification_type[0].minimum"
                            v-bind:max="option_calification_type[0].maximum"
                            step=".01"
                          >
                          </fg-input>
                        </div>
                      </div>
                      <div
                        class="row mb-3"
                        v-else-if="
                          option_calification_type[0] &&
                          option_calification_type[0].calification_type ==
                            'Única'
                        "
                        style="align-items: center"
                      >
                        <div
                          v-if="!option_calification_type[0].is_required"
                          class="col-2"
                        >
                          <el-checkbox
                            v-model="detailsForm.na"
                            label="N/A"
                          ></el-checkbox>
                        </div>
                        <div
                          v-if="
                            option_calification_type[0].is_required ||
                            !detailsForm.na
                          "
                          class="col-10"
                        >
                          <div class="form-group has-label mb-0">
                            <el-select
                              clearable
                              filterable
                              class="select-default shadow-sm required-select"
                              v-model="detailsForm.value_unique"
                              :placeholder="`${$t('common_words.select')}...`"
                              @focus="cleanInput"
                            >
                              <el-option
                                class="select-default"
                                v-for="(
                                  item, index
                                ) in option_calification_type[0]
                                  .audit_option_tasks"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div
                        class="row"
                        v-else-if="
                          option_calification_type[0] &&
                          option_calification_type[0].calification_type ==
                            'Múltiple'
                        "
                        style="align-items: center"
                      >
                        <div
                          v-if="!option_calification_type[0].is_required"
                          class="col-2"
                        >
                          <el-checkbox
                            v-model="detailsForm.na"
                            label="N/A"
                          ></el-checkbox>
                        </div>
                        <div
                          v-if="
                            option_calification_type[0].is_required ||
                            !detailsForm.na
                          "
                          class="col-10"
                        >
                          <div class="form-group has-label mb-0">
                            <el-select
                              @focus="cleanInput"
                              @change="
                                selectAllFromSelect(
                                  'detailsForm.value_multiple',
                                  option_calification_type[0].audit_option_tasks
                                )
                              "
                              multiple
                              collapse-tags
                              clearable
                              filterable
                              class="select-default mb-3 shadow-sm required-select"
                              v-model="detailsForm.value_multiple"
                              :placeholder="`${$t('common_words.select')}...`"
                            >
                              <el-option
                                class="select-default selected-all"
                                v-for="(item, index) in this.concatAll(
                                  option_calification_type[0].audit_option_tasks
                                )"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div
                        class="row mb-3"
                        v-else-if="
                          option_calification_type[0] &&
                          ['Fuente de Datos'].includes(
                            option_calification_type[0].calification_type
                          )
                        "
                        style="align-items: center"
                      >
                        <div
                          v-if="!option_calification_type[0].is_required"
                          class="col-2"
                        >
                          <el-checkbox
                            v-model="detailsForm.na"
                            label="N/A"
                          ></el-checkbox>
                        </div>
                        <div
                          v-if="
                            option_calification_type[0].is_required ||
                            !detailsForm.na
                          "
                          class="col-10"
                        >
                          <div class="form-group has-label mb-0">
                            <el-select
                              clearable
                              filterable
                              class="select-default shadow-sm required-select"
                              v-model="detailsForm.value"
                              :placeholder="`${$t('common_words.select')}...`"
                              @focus="cleanInput"
                            >
                              <el-option
                                class="select-default"
                                v-for="(item, index) in detailsForm.sources"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div
                        class="row mb-3"
                        v-else-if="
                          option_calification_type[0] &&
                          ['Fuente de Datos Múltiple'].includes(
                            option_calification_type[0].calification_type
                          )
                        "
                        style="align-items: center"
                      >
                        <div
                          v-if="!option_calification_type[0].is_required"
                          class="col-2"
                        >
                          <el-checkbox
                            v-model="detailsForm.na"
                            label="N/A"
                          ></el-checkbox>
                        </div>
                        <div
                          v-if="
                            option_calification_type[0].is_required ||
                            !detailsForm.na
                          "
                          class="col-10"
                        >
                          <div class="form-group has-label mb-0">
                            <el-select
                              @focus="cleanInput"
                              collapse-tags
                              @change="
                                selectAllFromSelect(
                                  'detailsForm.value_multiple',
                                  concatAll(detailsForm.sources)
                                )
                              "
                              multiple
                              clearable
                              filterable
                              class="select-default shadow-sm required-select"
                              v-model="detailsForm.value_multiple"
                              :placeholder="`${$t('common_words.select')}...`"
                            >
                              <el-option
                                class="select-default selected-all"
                                v-for="(item, index) in concatAll(
                                  detailsForm.sources
                                )"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <h4 v-else class="mt-0 mb-3">
                        <small class="text-muted"
                          >{{ $t('common_words.select_a_task') }}...</small
                        >
                      </h4>
                      <div class="row">
                        <div class="col-12">
                          <h6 class="text-muted">
                            2. {{ $t('common_words.inspection_detail') }}
                          </h6>
                          <hr />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group has-label">
                            <label class="text-transform-none">
                              {{ $t('common_words.observations') }}:</label
                            >
                            <br />
                            <el-input
                              maxlength="300"
                              show-word-limit
                              type="textarea"
                              :rows="2"
                              placeholder="..."
                              v-model="detailsForm.observations"
                              class="shadow-sm"
                            ></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group has-label">
                        <label class="text-transform-none">
                          {{ $t('common_words.observation') }}
                          {{ $t('common_words.general') }}:</label
                        >
                        <br />
                        <textarea
                          class="form-control shadow-sm"
                          v-model="detailsForm.observationSubjective"
                          placeholder="..."
                          maxlength="300"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-12 text-right">
                      <button
                        type="submit"
                        class="btn btn-fill btn-info btn-wd shadow-sm"
                      >
                        {{ $t('common_words.edit') }}
                      </button>
                    </div>
                  </div>
                </card>
              </form>
              <br />
            </el-dialog>
            <div class="col-12">
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mb-2"
              >
                <el-select
                  clearable
                  @clear="paginationDetails.perPage = 10"
                  filterable
                  class="select-default mb-3 shadow-sm"
                  style="width: 200px"
                  v-model="paginationDetails.perPage"
                  :placeholder="$t('common_words.per_page')"
                >
                  <el-option
                    class="select-default"
                    v-for="item in paginationDetails.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-input
                  clearable
                  class="mb-3 shadow-sm"
                  style="width: 200px"
                  :placeholder="$t('common_words.search_records')"
                  v-model="searchQueryDetails"
                  aria-controls="datatables"
                />
              </div>

              <!-- Tabla 2 Detalles ------------>

              <el-table
                :cell-style="handlecellstyle"
                stripe
                style="width: 100%"
                :data="queriedDataDetails"
                :border="true"
                max-height="700"
              >
                <el-table-column
                  v-for="column in tableColumnsDetails"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :sortable="column.sortable"
                  :fixed="column.fixed"
                  :formatter="column.formatter"
                  v-if="showColumn(column.show)"
                ></el-table-column>
                <el-table-column
                  :label="$t('common_words.data')"
                  min-width="200"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span v-html="scope ? scope.row.setValue : ''"></span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="`${$t('common_words.observations')}`"
                  min-width="250"
                >
                  <template slot-scope="scope">
                    {{ scope.row.observations }}
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common_words.image')"
                  min-width="150"
                >
                  <template slot-scope="scope">
                    <el-image
                      v-if="scope.row.image"
                      :src="scope.row.image"
                      :alt="$t('common_words.no_image')"
                      class="photo_capture"
                      @click="zoom(scope.row.image)"
                      :preview-src-list="srcList"
                    >
                      <div slot="error" class="image-slot"></div>
                    </el-image>
                    <span v-else></span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="`${$t('common_words.observations')}
                  ${$t('common_words.general')}`"
                  min-width="180"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-tooltip placement="top">
                      <div slot="content">
                        {{
                          zeroSubcateObservation
                            ? ''
                            : scope.row.subcategory_observation
                            ? getSubcategoryObservation(
                                scope.row.subcategory_observation.observation
                              )
                            : ''
                        }}
                      </div>
                      <a
                        class="btn-info btn-simple btn-link custom-margin-actions"
                      >
                        <em class="fa fa-eye custom-size-fa-actions"> </em>
                      </a>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  :min-width="90"
                  :label="$t('common_words.action')"
                  fixed="right"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="
                          props.row.audit_task_with_trashed.deleted_at
                            ? $t('common_words.task_notice')
                            : $t('common_words.edit')
                        "
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click="
                          !props.row.audit_task_with_trashed.deleted_at &&
                            handleEdit(props.$index, props.row)
                        "
                        :style="
                          props.row.audit_task_with_trashed.deleted_at
                            ? 'color: #888888'
                            : ''
                        "
                      >
                        <em class="fa fa-edit custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDeleteDetails(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <br />
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div class>
                  <p class="card-category">
                    {{ $t('table2.showing') }}
                    {{ fromDetails + 1 }} {{ $t('table2.a') }} {{ toDetails }}
                    {{ $t('table2.of') }}
                    {{ totalDetails }}
                    {{ $t('table2.entries') }}
                  </p>
                </div>
                <l-pagination
                  class="pagination-no-border"
                  v-model="paginationDetails.currentPage"
                  :per-page="paginationDetails.perPage"
                  :total="paginationDetails.total"
                  pageFirst="false"
                  pageLast="false"
                ></l-pagination>
              </div>
            </div>
          </div>
          <div v-if="isSuper()">
            <div class="row" style="padding-right: 13px; padding-left: 13px">
              <div class="col-6" v-if="isPDF()">
                <div class="text-right">
                  <button
                    class="btn btn-danger custom-shadow-btn"
                    @click="exportToPDF"
                  >
                    <em class="fa fa-file-pdf-o"></em>
                    {{ $t('common_words.export_to_pdf') }}
                  </button>
                </div>
              </div>
              <div class="col-6" v-if="isExcel()">
                <div class="text-left">
                  <button
                    class="btn custom-btn-success custom-shadow-btn"
                    @click="exportToExcel"
                  >
                    <em class="fa fa-file-excel-o"></em>
                    {{ $t('common_words.export_to_excel') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { getDateToday } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './competency-matriz-table';
import Filter from 'src/components/Filter/Filters.vue';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import Kpi from 'src/views/Layouts/Kpi.vue';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import store from '@/store';
import { isset } from 'src/util/Util';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      activeName: 'filter',
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },

      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        evaluations: [],
        farm: [],
        zones: [],
        activities: [],
      },
      details: false,
      detailsForm: {
        value_multiple: [],
        value_number: 0,
        value_unique: '',
        value: null,
        value_two: '',
        sources: [],
        na: false,
        observationSubjective: '',
      },
      evaluations: [],
      evaluationsSel: [],
      fuseSearchDetails: null,
      inspectionForm: {},

      modelValidations: {
        audit2_task_id: {
          required: true,
        },
        value: {
          required: true,
        },
        value_two: {
          required: true,
        },
      },
      option_calification_type: [],
      optTasks: [],
      paginationDetails: {},
      searchQueryDetails: '',
      srcList: [],
      subcategories: [],
      subcategory_id: null,
      tableColumns: [],
      tableColumnsDetails: [],
      tableDataDetails: [],

      valueCollapse: null,

      statisticDetails: {
        avg_objective: null,
        totalObjective: null,
        avg_compliance: null,
      },

      discount: 0,
      zeroSubcateObservation: false,

      activities: [],
      activitiesSel: [],
    };
  },

  components: {
    [Kpi.name]: Kpi,
    [Filter.name]: Filter,
    LPagination,
  },

  computed: {
    ...configTable().SearchDetails,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    dateToday() {
      return getDateToday();
    },
  },

  mixins: [
    MixinArcgisMap,
    MixinExport,
    MixinMasters,
    MixinMenu,
    MixinNotification,
    MixinForm,
    MixinPermissions,
  ],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll', 'setupTable'],
  },

  methods: {
    getSelectAll() {
      this.evaluations = this.concatAll(this.evaluations.splice(1));
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleFilter(data) {
      this.dataFilter = {
        ...this.dataFilter,
        datef: data.datef,
        datei: data.datei,
        bySel: data.bySel,
        farm: data.farm,
        zones: data.zones,
        calendar_sel: data.calendar_sel,
        activities: this.activitiesSel,
      };
      this.details = false;
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
      this.searchQuery = '';

      this.getDataSamples();
    },

    getDataSamples() {
      if (!isset(this.evaluationsSel)) {
        return this.validationInputsRequired('evaluations');
      }

      this.showHideLoading(true);
      let data = this.dataFilter;
      data.route = 'advanced/audits/inspections/filterhip';
      data.evaluations = this.evaluationsSel;
      data.activities = this.activitiesSel;
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
          }
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    setupTable() {
      const { Table, TableDetails } = configTable();
      this.pagination = { ...Table.pagination };
      this.tableColumns = Table.tableColumns;
      this.paginationDetails = { ...TableDetails.pagination };
      this.tableColumnsDetails = TableDetails.tableColumns;
    },

    // FUNCIONES TABLA DETALLES----------------
    handleView(index, row) {
      this.showHideLoading(true);
      this.details = false;
      this.rowData = row;
      this.rowData.index = index;

      this.tableData.forEach((element) => {
        if (element.id != this.rowData.id) element.show = true;
        else this.rowData.show = false;
      });

      Promise.all([
        Axios.getMasters(
          'advanced/audits/inspectionsdetails/' + this.rowData.code
        ),
        Axios.getMasters(
          'advanced/audits/subcategories/' + this.rowData.evaluation_id
        ),
      ])
        .then((response) => {
          const [responseDetails, responseSubCategories] = response;
          this.tableDataDetails = responseDetails.data.data;
          this.zeroSubcateObservation =
            this.tableDataDetails[0].zero_subject_observation;
          this.statisticDetails = this.tableDataDetails.pop();
          this.subcategories = responseSubCategories.data.data;

          this.fuseSearchDetails = new Fuse(this.tableDataDetails, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumnsDetails
              .map((prop) => {
                return prop.prop;
              })
              .concat(['code', 'value']),
          });
          this.details = true;
          this.paginationDetails.currentPage = 1;
          this.showHideLoading();

          setTimeout(() => {
            window.scrollTo({
              top: document.getElementsByClassName('footer')[0].offsetTop - 500,
              behavior: 'smooth',
            });
          }, 100);
        })
        .catch((error) => {
          this.showHideLoading();
          this.rowData.show = true;
          SweetAlert.warning(error.response.data.message);
        });
    },
    zoom(url) {
      this.srcList = [];
      this.srcList.push(url);
    },
    handleViewDetails() {
      this.details = !this.details;
      this.tableData.forEach((element) => {
        try {
          element.show = true;
        } catch (error) {
          //
        }
      });
    },

    //Funciones para Exportar Formatos Excel & PDF
    exportToPDFAllInspectionsWithDetails() {
      let inspectionsIds = [];
      this.tableData.forEach((inspection) => {
        inspectionsIds.push(inspection.id);
      });
      let data = {};
      data.inspectionsIds = inspectionsIds;
      data.export_mode = 'matriz';
      data.route =
        'advanced/audits/inspectionsdetails/pdfallinspectiondetailcustom';
      data.name_file = `${i18n.t('grow.details_competency_matriz_report')}_${
        this.dateToday
      }.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToEXCELAllInspectionsWithDetails() {
      let inspectionsIds = [];
      this.tableData.forEach((inspection) => {
        inspectionsIds.push(inspection.id);
      });
      let data = {};
      data.inspectionsIds = inspectionsIds;
      data.export_mode = 'hip';
      data.route =
        'advanced/audits/inspectionsdetails/excelallinspectiondetailcustom';
      data.name_file = `${i18n.t('grow.details_competency_matriz_report')}_${
        this.dateToday
      }.xlsx`;
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    showColumn(show) {
      if (typeof show === 'undefined') return true;
      else if (typeof show !== 'undefined' || show !== null) return show;
    },

    // Funciones tabla 2 Detalles
    handleCloseSamplesMap() {
      this.modals.map = false;
    },

    handleViewSamplesMap() {
      this.modals.map = true;
      this.showHideLoading(true);

      let points = [];
      this.tableDataDetails.forEach((element) => {
        let pll = new Object();
        pll.lat = parseFloat(element.latitude);
        pll.lng = parseFloat(element.longitude);

        this.center.lat = element.latitude
          ? parseFloat(element.latitude)
          : this.center.lat;
        this.center.lng = element.longitude
          ? parseFloat(element.longitude)
          : this.center.lng;

        points.push(pll);
      });

      setTimeout(() => {
        this.loadBaseMap(
          this.rowData.farm_id,
          true,
          true,
          this.$refs.multipleMap,
          points,
          19
        );
        document.getElementById('toolbarDiv').style = 'top: 16%;right: 18px;';
        this.showHideLoading();
      }, 10);
    },

    handleClose(done) {
      this.detailsForm = {
        value: null,
        na: false,
        value_number: 0,
        value_unique: '',
        value_multiple: [],
        value_two: '',
        sources: [],
        observationSubjective: '',
      };
    },

    handleDeleteDetails(_, row) {
      this.detailsForm = Object.assign({}, row);
      SweetAlert.delete(
        `${i18n.t('common_words.associated_data')} 
        ${this.detailsForm.audit_task_with_trashed.name}
        `
      ).then((result) => {
        if (result.value) this.deleteDetail();
      });
    },

    deleteDetail() {
      this.showHideLoading(true);
      if (this.isDelete()) {
        if (this.tableDataDetails.length == 1) {
          this.rowData.deleteHeader = true;
        }

        this.detailsForm.route = 'advanced/audits/inspectionsdetails';
        Axios.destroyMaster(this.detailsForm)
          .then((response) => {
            let indexToDelete = this.tableDataDetails.findIndex(
              (tableRow) => tableRow.id === this.detailsForm.id
            );
            if (indexToDelete >= 0) {
              this.tableDataDetails.splice(indexToDelete, 1);
              if (this.rowData.deleteHeader) {
                let indexToDelete = this.tableData.findIndex(
                  (tableRow) => tableRow.id === this.rowData.id
                );
                this.tableData.splice(indexToDelete, 1);
                this.details = false;
              }
            }

            this.statisticDetails = response.data.data;
            this.showHideLoading();
            this.showNotification(
              i18n.t('common_words.deleted_detail') +
                this.detailsForm.audit_task_with_trashed.name +
                i18n.t('ad_audit.selected_inspection_check'),
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    handleDelete(_, row) {
      this.inspectionForm = Object.assign({}, row);
      SweetAlert.delete(
        i18n.t('quality.quality_code_test') + this.inspectionForm.code
      ).then((result) => {
        if (result.value) this.deleteInspection();
      });
    },

    deleteInspection() {
      this.showHideLoading(true);
      if (this.isDelete()) {
        this.inspectionForm.route = 'advanced/audits/inspections';
        Axios.destroyMaster(this.inspectionForm)
          .then((response) => {
            this.modifyTable(2, this.inspectionForm.id, response);
            this.showHideLoading();
            this.handleViewDetails();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    cleanInput() {
      try {
        const v = document
          .getElementsByClassName('required-select')[0]
          .querySelector('div .el-input__inner').value;
        document
          .getElementsByClassName('required-select')[0]
          .querySelector('div .el-input__inner').value = '';
        document
          .getElementsByClassName('required-select')[0]
          .querySelector('div .el-input__inner').value = v;
      } catch (error) {}
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          const calificationType =
            this.detailsForm.audit_task_with_trashed.calification_type;
          const isRequired =
            this.detailsForm.audit_task_with_trashed.is_required;
          const value = this.detailsForm.value;
          let valueTwo = this.detailsForm.value_two;
          const valueMultiple = this.detailsForm.value_multiple;
          const valueUnique = this.detailsForm.value_unique;
          if (
            calificationType == 'Subjetiva' &&
            isRequired &&
            (!(Number(value) >= 0 && Number(value) <= 10) || value === null)
          ) {
            return store
              .dispatch('utils/validationInputsRequired', '-value')
              .catch((error) => console.log(error));
          } else {
            if (
              (valueMultiple && valueMultiple.length == 0 && isRequired) ||
              (calificationType == 'Única' &&
                (!valueUnique || (valueUnique && valueUnique.length == 0)) &&
                isRequired)
            ) {
              return store
                .dispatch('utils/validationInputsRequired', '-select')
                .catch((error) => console.log(error));
            } else {
              if (
                (calificationType == 'Fecha' &&
                  (valueTwo === null || valueTwo.length === 0) &&
                  isRequired) ||
                (calificationType == 'Hora' &&
                  (valueTwo === null || valueTwo.length === 0) &&
                  isRequired)
              ) {
                return store
                  .dispatch('utils/validationInputsRequired', '-value_two')
                  .catch((error) => console.log(error));
              } else {
                if (
                  calificationType == 'Fuente de Datos' &&
                  (value === null || value.length === 0) &&
                  isRequired
                ) {
                  return store
                    .dispatch('utils/validationInputsRequired', '-select')
                    .catch((error) => console.log(error));
                } else {
                  if (!this.subcategory_id) {
                    return store
                      .dispatch(
                        'utils/validationInputsRequired',
                        '-subcategory'
                      )
                      .catch((error) => console.log(error));
                  } else {
                    if (!this.detailsForm.audit2_task_id) {
                      return store
                        .dispatch('utils/validationInputsRequired', '-task')
                        .catch((error) => console.log(error));
                    } else {
                      this.modals['read'] = false;
                      this.showHideLoading(true);
                      if (this.isUpdate()) {
                        this.detailsForm.route =
                          'advanced/audits/inspectionsdetails';
                        if (calificationType === 'Fecha') {
                          valueTwo = moment(valueTwo).format('YYYY-MM-DD');
                        } else if (calificationType === 'Hora') {
                          valueTwo = moment(valueTwo).format('HH:mm:ss');
                        }

                        if (
                          this.detailsForm.na &&
                          [
                            'Subjetiva',
                            'Objetiva',
                            'Numérica',
                            'Fuente de Datos',
                          ].includes(calificationType)
                        ) {
                          const indexSet =
                            calificationType === 'Numérica'
                              ? 'value_number'
                              : 'value';
                          this.$set(this.detailsForm, indexSet, null);
                        }
                        Axios.updateMaster(this.detailsForm)
                          .then((response) => {
                            this.showHideLoading();
                            SweetAlert.success(response.data.message).then(
                              () => {
                                this.statisticDetails =
                                  response.data.data.pop();
                                let responseData = response.data.data[0];
                                const filteredData = responseData.slice(0, -1);
                                this.tableDataDetails = filteredData;
                              }
                            );
                          })
                          .catch((error) => {
                            this.showHideLoading();
                            this.showMessageErrors(error);
                          });
                      } else {
                        this.showMessageAccess();
                        this.showHideLoading();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
    },

    handleEdit(index, row) {
      this.detailsForm = Object.assign({}, row);
      this.detailsForm.index = index;
      this.detailsForm.observationSubjective = row.subcategory_observation
        ? row.subcategory_observation.observation
        : '';
      if (
        ['Objetiva', 'Fuente de Datos', 'Fecha', 'Hora', 'Texto'].includes(
          row.audit_task_with_trashed.calification_type
        )
      ) {
        this.$set(
          this.detailsForm,
          'na',
          !row.audit_task_with_trashed.is_required &&
            row.setValue === 'NA' &&
            !row.value
        );

        if (row.audit_task_with_trashed.calification_type === 'Texto') {
          this.modelValidations.value_two.required = row.audit_task_with_trashed
            .is_required
            ? true
            : false;
        }
      } else if (
        ['Múltiple', 'Fuente de Datos Múltiple', 'Única'].includes(
          row.audit_task_with_trashed.calification_type
        )
      ) {
        this.$set(
          this.detailsForm,
          'na',
          !row.audit_task_with_trashed.is_required && row.setValue === 'NA'
        );
      } else if (
        ['Numérica'].includes(row.audit_task_with_trashed.calification_type)
      ) {
        this.modelValidations.value.required = row.audit_task_with_trashed
          .is_required
          ? true
          : false;
        this.$set(
          this.detailsForm,
          'na',
          !row.audit_task_with_trashed.is_required &&
            row.setValue === 'NA' &&
            !row.value_number
        );
      }

      if (row.audit_task_with_trashed.calification_type === 'Fecha') {
        let dataDate = new Date();
        if (row.value_two !== 'Invalid date')
          dataDate = new Date(row.value_two.replace(/-/, '/'));
        this.$set(this.detailsForm, 'value_two', dataDate);
      } else if (row.audit_task_with_trashed.calification_type === 'Hora') {
        const hour = this.detailsForm.value_two.split(':');
        this.detailsForm.value_two = new Date(
          0,
          0,
          0,
          hour[0] ? hour[0] : 0,
          hour[1] ? hour[1] : 0,
          hour[2] ? hour[2] : 0
        );
      }

      this.subcategory_id =
        this.detailsForm.audit_task_with_trashed.audit2_subcategory_id;
      this.modals['read'] = true;
      this.updateTask();
      this.cleanInput();
    },

    updateTask() {
      this.optTasks = Object.assign({}, []);
      let find = false;
      for (let index = 0; index < this.subcategories.length; index++) {
        const element = this.subcategories[index];
        if (this.subcategory_id == element.id) {
          find = element.audit_tasks.length > 0 ? true : false;
          this.optTasks = Object.assign({}, find ? element.audit_tasks : []);
          this.detailsForm.audit2_task_id =
            this.detailsForm.audit_task_with_trashed.audit2_subcategory_id !=
            element.id
              ? null
              : this.detailsForm.audit2_task_id;
          this.updateInputTypeValue();
          break;
        }
      }
    },

    updateInputTypeValue() {
      this.option_calification_type = Object.values(this.optTasks).filter(
        (item) => {
          if (this.detailsForm.audit2_task_id == item.id) {
            return item.calification_type;
          }
        }
      );
    },

    handlecellstyle({ row, columnIndex }) {
      if (columnIndex == 1 && row.setValue === 'NA') {
        return 'background-color: #9d9d9d; color: white';
      }

      if (
        columnIndex == 1 &&
        row.audit_task_with_trashed &&
        row.audit_task_with_trashed.calification_type === 'Objetiva'
      ) {
        switch (row.setValue) {
          case 'Si':
            return 'background-color: #20a857; color: white';
          case 'No':
            return 'background-color: #ff4c4c; color: white';

          default:
            break;
        }
      } else {
        if (
          columnIndex == 1 &&
          row.audit_task_with_trashed &&
          row.audit_task_with_trashed.calification_type === 'Subjetiva'
        ) {
          if (row.setValue >= 0 && row.setValue <= 4)
            return 'background-color: #ff4c4c; color: white';
          if (row.setValue >= 5 && row.setValue <= 7)
            return 'background-color: #FEDB39; color: black';
          if (row.setValue >= 8 && row.setValue <= 10)
            return 'background-color: #20a857; color: white';
          if (row.setValue == 11 || row.setValue === 'NA')
            return 'background-color: #9d9d9d; color: white';
        }
        if (
          columnIndex == 1 &&
          row.audit_task_with_trashed &&
          row.audit_task_with_trashed.calification_type === 'Subjetiva 2'
        ) {
          if (row.setValue >= 0 && row.setValue <= 2)
            return 'background-color: #ff4c4c; color: white';
          if (row.setValue >= 3 && row.setValue <= 4)
            return 'background-color: #FEDB39; color: black';
          if (row.setValue == 5)
            return 'background-color: #20a857; color: white';
          if (row.setValue == 6 || row.setValue === 'NA')
            return 'background-color: #9d9d9d; color: white';
        } else {
          return '';
        }
      }
    },

    getSubcategoryObservation(observation) {
      return observation;
    },

    exportToExcel() {
      let data = {};
      const evaluationName = this.rowData.evaluation_name;
      const date = this.rowData.date;
      data.route =
        'advanced/audits/inspectionsdetails/excel/' +
        this.rowData.code +
        '?export_mode=hip';
      data.name_file = `${i18n.t(
        'grow.detailed_competency_matriz_report'
      )}_${evaluationName}_${date}.xlsx`;

      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToPDF() {
      let data = {};
      const evaluationName = this.rowData.evaluation_name;
      const date = this.rowData.date;
      data.route =
        'advanced/audits/inspectionsdetails/pdf/' +
        this.rowData.code +
        '?export_mode=matriz';
      data.name_file = `${i18n.t(
        'grow.detailed_competency_matriz_report'
      )}_${evaluationName}_${date}.pdf`;

      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();

      Promise.all([
        Axios.getMasters('grow/hipreport/inspections'),
        Axios.getMasters('grow/hipreport/trainings?source=hip'),
      ]).then(([responseEvaluations, responseTrainings]) => {
        this.evaluations = this.concatAll(responseEvaluations.data.data);
        this.activities = this.concatAllActivities(responseTrainings.data.data);

        if (this.evaluations.length > 1) {
          this.evaluationsSel = [this.evaluations[1].id];
        }
      });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('lossreport');
  },

  destroyed() {
    this.deselectedItemOnMenu('lossreport');
  },
};
</script>
<style scoped></style>
